import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ImageConfiguration } from '../../../models/image-configuration';

@Component({
  selector: 'app-dashboard-slider',
  templateUrl: './dashboard-slider.component.html',
  styleUrls: ['./dashboard-slider.component.scss']
})
export class DashboardSliderComponent implements OnInit, OnDestroy {
  @ViewChild('canvas', { static: true }) canvas!: ElementRef<HTMLCanvasElement>;
  @Input() slideNumber: number;
  @Input() imageSrc: string;
  @Input() title: string;
  @Input() info: string;
  @Input() resturantId: number;
  @Input() imgMetaData: any;

  private intersectionObserver?: IntersectionObserver;
  private hasDrawn = false;

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    // Only the visible slide paints immediately. The rest wait until keen-slider
    // brings them near the viewport — opening the dashboard used to download and
    // canvas-draw every hero image at once.
    if (this.slideNumber === 1 || typeof IntersectionObserver === 'undefined') {
      this.cropImage();
      return;
    }
    this.intersectionObserver = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.intersectionObserver?.disconnect();
        this.intersectionObserver = undefined;
        this.cropImage();
      }
    }, { rootMargin: '300px 0px 300px 0px' });
    this.intersectionObserver.observe(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.intersectionObserver?.disconnect();
  }

  cropImage() {
    if (this.imgMetaData) {
      const canvas = this.canvas.nativeElement;
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        console.log("ctx error");
        return;
      }

      this.hasDrawn = true;
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = this.imageSrc;

      img.onload = () => {
        canvas.width = window.innerWidth;
        canvas.height = this.imgMetaData.imageType == 1 ? 532 : 268;

        ctx.drawImage(
          img,
          this.imgMetaData.x, this.imgMetaData.y,
          this.imgMetaData.width, this.imgMetaData.height,
          0, 0,
          window.innerWidth, canvas.height
        );
      }

      img.onerror = () => {
        img.src = this.imageSrc;
      }
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // Redraw only slides that have painted; a resize must not force-load the
    // images the observer is still deferring.
    if (this.hasDrawn) {
      this.cropImage();
    }
  }
}
